export const VENUE_UUID = "e17ccb29-ce79-4567-8682-57133fae75a9"